<template>
    <router-link :to="link" :class="readStatus" class="group rounded-md shadow-md p-4 hover:bg-blue/5 flex flex-col justify-between transition-all ease-in-out duration-500">
        <div class="flex flex-col lg:flex-row gap-4 lg:items-center">
            <!-- Product icon -->
            <div v-if="data?.product" class="text-white w-[50px] h-[50px] flex-shrink-0">
                <img :alt="$translate(data?.product.name)" class="w-full h-full object-contain" :src="data.product.image.replace('.png', '-gradient.png')" />
            </div>

            <!-- else HKCM logo -->
            <div v-else class="text-white w-[50px] h-[50px] flex-shrink-0">
                <img class="w-full h-full object-contain" :src="$asset('/hkcm/images/logo-small-on-light-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
            </div>

            <div>
                <strong v-if="data?.product">
                    {{ $translate(data.product.name) }}
                </strong>

                <br />
                <small class="block" v-if="data.title && $translate(data.title) != $translate(data?.product?.name)">
                    {{ $translate(data.title) }}
                </small>
                <small>
                    {{ $translate(data.contentstreamType.title) }}
                </small>
            </div>
        </div>

        <div aria-label="card-footer">
            <hr class="border-t border-gray-300 my-4 group-hover:border-white transition-all ease-in-out duration-500" />

            <div class="flex justify-between items-center mt-2">
                <div class="rounded-full lg:bg-blue-light lg:p-1.5 flex flex-row gap-2 items-center">
                    <div class="hidden lg:block w-3 h-3 rounded-full bg-blue transition-all ease-in-out duration-500" />
                    <p class="text-xxs leading-none">
                        {{ $moment(data.published_at).format('DD.MM.YYYY') }}
                    </p>
                </div>
                <div class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center">
                    <span class="hidden lg:block text-xs">
                        {{ $t('read_more') }}
                    </span>
                    <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current" />
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: ['data', 'page', 'active_tab', 'query_params'],
    computed: {
        ...mapGetters('user', {
            user: 'get'
        }),

        readStatus() {
            // NOTE: Safeguard check just for test period
            // TODO: Remove this check after test period
            if (this.user.email.endsWith('@hkcmanagement.de') === false) {
                return 'bg-white';
            }

            // NOTE: Conditions to show an unread item:
            // 1. The item read status is false
            // 2. The item read status is null (indicates a new item/analysis)
            //    and the item should have the latets date (not older than 40 day)
            const isUnread = this.data?.read_status?.is_read === false ? true : false;
            const isUnset = this.data?.read_status === null ? true : false;

            const pubDate = this.$moment(this.data?.published_at).format('YYYY-MM-DD');
            const dateLimit = this.$moment().subtract(40, 'days').format('YYYY-MM-DD');
            const inTimeRange = this.data?.read_status === null && pubDate > dateLimit ? true : false;

            return isUnread || (isUnset && inTimeRange) ? 'bg-blue/10 border border-blue/50' : 'bg-white';
        },

        background() {
            let backgroundColor = this.data?.product?.productGroups?.data[0]?.productCategories?.data[0]?.background_color;
            let backgroundGradient = this.data?.product?.productGroups?.data[0]?.productCategories?.data[0]?.background_gradient;

            return 'linear-gradient(to bottom, ' + backgroundColor + ' 0%, ' + backgroundGradient + ' 100%)';
        },

        link() {
            if (this?.query_params) {
                return `/dashboard/contentstreams/${this?.data?.id}?${this?.query_params}`;
            } else {
                return `/dashboard/contentstreams/${this?.data?.id}`;
            }
        }
    }
};
</script>

<style scoped>
.icon {
    background: v-bind(background);
}
</style>
